import { ProductCategory } from "@utils/constants";
import { isPair, isParcel } from "./productValidators";

const getProductName = (productType: string, t?: any) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return t
        ? t("global.text.naturalDiamonds", "Natural Diamonds")
        : "Natural Diamonds";
    case ProductCategory.GEMSTONE:
      return t
        ? t("global.text.coloredGemstones", "Colored Gemstones")
        : "Colored Gemstones";
    case ProductCategory.JEWELRY:
      return t ? t("global.text.jewelry", "Jewelry") : "Jewelry";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return t
        ? t("global.text.labGrownDiamonds", "Lab-Grown Diamonds")
        : "Lab-Grown Diamonds";
    case ProductCategory.LABGROWN_JEWELRY:
      return t
        ? t("global.text.labGrownJewelry", "Lab-Grown Jewelry")
        : "Lab-Grown Jewelry";
  }
};

const getRequestProductName = (
  productType: string,
  item?: any,
  t?: any,
  isBulkItem?: boolean,
  isCustomApp?: boolean
) => {
  let productName = "";
  const pairType = isBulkItem
    ? t("productDetail.pairs.text", "Pairs")
    : t("productDetail.pair.text", "Pair");

  const parcelType = t("productDetail.parcels.text", "Parcels");

  switch (productType) {
    case ProductCategory.DIAMOND:
      productName = "Natural Diamonds";
      break;
    case ProductCategory.GEMSTONE:
      productName = "Colored Gemstones";
      break;
    case ProductCategory.JEWELRY:
      productName = "Jewelry";
      break;
    case ProductCategory.LAB_GROWN_DIAMOND:
      productName = "Lab-Grown Diamonds";
      break;
    case ProductCategory.LABGROWN_JEWELRY:
      productName = "Lab-Grown Jewelry";
      break;
    default:
      productName = "Multiple Items";
      break;
  }

  if (item) {
    if (isPair(item)) {
      productName = `${productName} ${pairType}`;
    } else if (isCustomApp && isParcel(item)) {
      productName = `${productName} ${parcelType}`;
    }
  }

  return {
    productName,
  };
};

const getSearchFilterProductName = (productType: string, t: any) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return t
        ? t(
            "global.text.naturalDiamondsFilters.text",
            "Natural Diamonds Filters"
          )
        : "Natural Diamonds Filters";
    case ProductCategory.GEMSTONE:
      return t
        ? t(
            "global.text.coloredGemstonesFilters.text",
            "Colored Gemstones Filters"
          )
        : "Colored Gemstones Filters";
    case ProductCategory.JEWELRY:
      return t
        ? t("global.text.jewelryFilters.text", "Jewelry Filters")
        : "Jewelry Filters";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return t
        ? t(
            "global.text.labGrownDiamondsFilters.text",
            "Lab-Grown Diamonds Filters"
          )
        : "Lab-Grown Diamonds Filters";
    case ProductCategory.LABGROWN_JEWELRY:
      return t
        ? t(
            "global.text.labGrownJewelryFilters.text",
            "Lab-Grown Jewelry Filters"
          )
        : "Lab-Grown Jewelry Filters";
  }
};

const getSearchResultProductName = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "Natural Diamonds Results";
    case ProductCategory.GEMSTONE:
      return "Colored Gemstones Results";
    case ProductCategory.JEWELRY:
      return "Jewelry Filters";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "Lab-Grown Diamonds Results";
    case ProductCategory.LABGROWN_JEWELRY:
      return "Lab-Grown Jewelry Results";
  }
};

export {
  getProductName,
  getRequestProductName,
  getSearchFilterProductName,
  getSearchResultProductName,
};
